import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeFormatter, LocalTime } from 'js-joda';

const timeFormat = DateTimeFormatter.ofPattern('hh:mm:ss');

@Pipe({
  name: 'timeFormat'
})
export class TimeFormatPipe implements PipeTransform {
  transform(value: any, args?: any): string {
    // js-joda does not use @js-joda/locale_ correctly to convert 24 hour clock to 12 hour clock , using this method until it is fixed
    // https://github.com/js-joda/js-joda/issues/285
    if (value) {
      const localTime: LocalTime = LocalTime.parse(value);
      if (localTime.hour() < 12) {
        return localTime.format(timeFormat) + ' AM';
      } else {
        return localTime.format(timeFormat) + ' PM';
      }
    }
  }
}
